import { Box, Stack, Typography } from '@mui/material'
import React from 'react'
import { Helmet } from 'react-helmet'

import Content from 'components/common/Content'
import PageSection from 'components/common/PageSection'
import { Header } from 'components/navigation/Header'
import { CloneTestSuiteButton } from 'components/test-suites/CloneTestSuiteButton'
import { TestSuiteForm } from 'components/test-suites/forms/TestSuiteForm'
import { useTestSuiteFormContext } from 'components/test-suites/forms/TestSuiteFormContext'
import { TestSuitesBreadcrumbs } from 'components/test-suites/TestSuitesBreadcrumbs'
import { useTranslation } from 'hooks/use-translation'
import theme from 'theme'
import { messageFromResponseError } from 'utils/strings'

export const EditTestSuitePage: React.FC = () => {
  const { trans } = useTranslation()
  const {
    canCreateAndEditTestSuites,
    isOfficialTestSuite,
    queryResultTestSuite
  } = useTestSuiteFormContext()

  const {
    data: testSuite,
    error: errorTestSuite,
    isError: isErrorTestSuite,
    isFetching: isFetchingTestSuite
  } = queryResultTestSuite

  const pageTitleForCustomTestSuite = canCreateAndEditTestSuites
    ? trans('test_suite.edit.page_title', {
        testSuiteName: testSuite?.name
      })
    : trans('test_suite.edit.page_title_read_only', {
        testSuiteName: testSuite?.name
      })

  return (
    <>
      <Helmet
        title={
          isOfficialTestSuite ? testSuite?.name : pageTitleForCustomTestSuite
        }
      />
      <Header>
        <TestSuitesBreadcrumbs>
          <Typography color="text.primary">{testSuite?.name}</Typography>
        </TestSuitesBreadcrumbs>
      </Header>
      <Content
        css={{
          display: 'grid',
          gridTemplateColumns: 'minmax(0, 1fr)',
          gridAutoRows: 'min-content'
        }}
      >
        <PageSection
          errorMessage={messageFromResponseError(
            errorTestSuite,
            trans('test_suites.errors.page_loading_error')
          )}
          hasError={isErrorTestSuite}
          isLoading={isFetchingTestSuite}
        >
          <Stack>
            <Stack direction="row" flexWrap="wrap" gap={3}>
              <Typography variant="h5">{testSuite?.name}</Typography>
              {canCreateAndEditTestSuites && testSuite && (
                <CloneTestSuiteButton testSuite={testSuite} />
              )}
            </Stack>
            {testSuite?.description && (
              <Typography css={{ marginTop: theme.space[2] }} variant="body1">
                {testSuite?.description}
              </Typography>
            )}
            <Box sx={{ mt: 4 }}>
              <TestSuiteForm />
            </Box>
          </Stack>
        </PageSection>
      </Content>
    </>
  )
}
